import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';

const InstituteDashboardTeacherList = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const [isActive, setIsactive] = useState(true);
    const [activeList, setActiveList] = useState([]);
    const [inActiveList, setInActiveList] = useState([]);

    const [startIndexActive, setStartIndexActive] = useState(null);
    const [startIndexInActive, setStartIndexInActive] = useState(null);
    const [currPageActive, setCurrPageActive] = useState(1);
    const [currPageInActive, setCurrPageInActive] = useState(1);
    const [itemsPerPageActive, setItemsPerPageActive] = useState(10);
    const [itemsPerPageInActive, setItemsPerPageInActive] = useState(10);
    const [displayedDataActive, setDisplayedDataActive] = useState([]);
    const [displayedDataInActive, setDisplayedDataInActive] = useState([]);
    const [totalPagesActive, setTotalPagesActive] = useState(0);
    const [totalPagesInActive, setTotalPagesInActive] = useState(0);

    const [teacherNameActiveSort, setTeacherNameActiveSort] = useState(null);
    const [joiningDateActiveSort, setJoiningDateActiveSort] = useState(null);
    const [dobActiveSort, setDobActiveSort] = useState(null);
    const [genderActiveSort, setGenderActiveSort] = useState(null);

    const [teacherNameInActiveSort, setTeacherNameInActiveSort] = useState(null);
    const [joiningDateInActiveSort, setJoiningDateInActiveSort] = useState(null);
    const [dobInActiveSort, setDobInActiveSort] = useState(null);
    const [genderInActiveSort, setGenderInActiveSort] = useState(null);

    const [searchValueActive, setSearchValueActive] = useState(null);
    const [searchValueInActive, setSearchValueInActive] = useState(null);
    const searchKeys = ["teacherName", "email", "joiningDate", "dob", "contactNumber", "gender", "qualification", "address"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getActiveTeachers();
        getInActiveTeachers();
    }, [])

    const getApiUrlActive = () => {
        return `/get-active-teachers?instituteMasterId=${instituteMasterId}`;
    }

    const getApiUrlInActive = () => {
        return `/get-deactive-teachers?instituteMasterId=${instituteMasterId}`;
    }

    const getActiveTeachers = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlActive();
            const response = await authorizedAxiosCommon.get(apiUrl);
            setActiveList(response.data.result);
        } catch (error) {
            setActiveList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getInActiveTeachers = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlInActive();
            const response = await authorizedAxiosCommon.get(apiUrl);
            setInActiveList(response.data.result);
        } catch (error) {
            setInActiveList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchValueActive === '' && searchValueActive !== null) {
            setCurrPageActive(1);
            getActiveTeachers();
        }
    }, [searchValueActive]);

    useEffect(() => {
        if (searchValueInActive === '' && searchValueInActive !== null) {
            setCurrPageInActive(1);
            getInActiveTeachers();
        }
    }, [searchValueInActive]);

    const handleEmptySearchActive = (e) => {
        setSearchValueActive(e.target.value);
    }

    const handleEmptySearchInActive = (e) => {
        setSearchValueInActive(e.target.value);
    }

    const handleSearchActive = async () => {
        if (searchValueActive !== null) {
            setCurrPageActive(1);
            setActiveList(await searchArray("C", getApiUrlActive(), searchKeys, searchValueActive.trim()));
        }
    }

    const handleSearchInActive = async () => {
        if (searchValueInActive !== null) {
            setCurrPageInActive(1);
            setInActiveList(await searchArray("C", getApiUrlInActive(), searchKeys, searchValueInActive.trim()));
        }
    }


    useEffect(() => {
        setTotalPagesActive(Math.ceil(activeList.length / itemsPerPageActive));
        const startIndexActive = (currPageActive - 1) * itemsPerPageActive;
        let endIndexActive = startIndexActive + itemsPerPageActive;

        if (endIndexActive > activeList.length) {
            endIndexActive = activeList.length;
        }
        setStartIndexActive(startIndexActive);
        setDisplayedDataActive(activeList.slice(startIndexActive, endIndexActive));
    }, [activeList, currPageActive, itemsPerPageActive]);

    useEffect(() => {
        setTotalPagesInActive(Math.ceil(inActiveList.length / itemsPerPageInActive));
        const startIndexInActive = (currPageInActive - 1) * itemsPerPageInActive;
        let endIndexInActive = startIndexInActive + itemsPerPageInActive;

        if (endIndexInActive > inActiveList.length) {
            endIndexInActive = inActiveList.length;
        }
        setStartIndexInActive(startIndexInActive);
        setDisplayedDataInActive(inActiveList.slice(startIndexInActive, endIndexInActive));
    }, [inActiveList, currPageInActive, itemsPerPageInActive])


    const dateFormate = (dateString) => {
        const originalDate = new Date(dateString);
        const formattedDate = originalDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });

        return formattedDate
    }

    useEffect(() => {
        if (teacherNameActiveSort == true || teacherNameActiveSort == false) {
            setJoiningDateActiveSort(null);
            setDobActiveSort(null);
            setGenderActiveSort(null);
        }
    }, [teacherNameActiveSort])

    useEffect(() => {
        if (joiningDateActiveSort == true || joiningDateActiveSort == false) {
            setTeacherNameActiveSort(null);
            setDobActiveSort(null);
            setGenderActiveSort(null);
        }
    }, [joiningDateActiveSort])

    useEffect(() => {
        if (dobActiveSort == true || dobActiveSort == false) {
            setTeacherNameActiveSort(null);
            setJoiningDateActiveSort(null);
            setGenderActiveSort(null);
        }
    }, [dobActiveSort])

    useEffect(() => {
        if (genderActiveSort == true || genderActiveSort == false) {
            setTeacherNameActiveSort(null);
            setJoiningDateActiveSort(null);
            setDobActiveSort(null);
        }
    }, [genderActiveSort])



    useEffect(() => {
        if (teacherNameInActiveSort == true || teacherNameInActiveSort == false) {
            setJoiningDateInActiveSort(null);
            setDobInActiveSort(null);
            setGenderInActiveSort(null);
        }
    }, [teacherNameInActiveSort])

    useEffect(() => {
        if (joiningDateInActiveSort == true || joiningDateInActiveSort == false) {
            setTeacherNameInActiveSort(null);
            setDobInActiveSort(null);
            setGenderInActiveSort(null);
        }
    }, [joiningDateInActiveSort])

    useEffect(() => {
        if (dobInActiveSort == true || dobInActiveSort == false) {
            setTeacherNameInActiveSort(null);
            setJoiningDateInActiveSort(null);
            setGenderInActiveSort(null);
        }
    }, [dobInActiveSort])

    useEffect(() => {
        if (genderInActiveSort == true || genderInActiveSort == false) {
            setTeacherNameInActiveSort(null);
            setJoiningDateInActiveSort(null);
            setDobInActiveSort(null);
        }
    }, [genderInActiveSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Teacher List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Teacher List</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <button className={`${isActive ? 'active' : ''} btn btn-light btn-width`} onClick={() => setIsactive(true)}>Active List</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${isActive ? '' : 'active'} btn btn-light btn-width`} onClick={() => setIsactive(false)}>Inactive List</button>
                                                            </div>
                                                        </div>

                                                        {!isActive &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueInActive}
                                                                        onChange={handleEmptySearchInActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchInActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchInActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Teacher Name
                                                                                <SortIcon sortState={teacherNameInActiveSort} setSortState={setTeacherNameInActiveSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"teacherName"} />
                                                                            </th>
                                                                            <th scope="col">Email Id</th>
                                                                            <th scope="col">
                                                                                Joining Date
                                                                                <SortIcon sortState={joiningDateInActiveSort} setSortState={setJoiningDateInActiveSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"joiningDate"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Date Of Birth
                                                                                <SortIcon sortState={dobInActiveSort} setSortState={setDobInActiveSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"dob"} />
                                                                            </th>
                                                                            <th scope='col'>Mobile No</th>
                                                                            <th scope='col'>
                                                                                Gender
                                                                                <SortIcon sortState={genderInActiveSort} setSortState={setGenderInActiveSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"gender"} />
                                                                            </th>
                                                                            <th scope='col'>Qualification</th>
                                                                            <th scope='col'>Address</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataInActive?.length > 0 ?
                                                                                displayedDataInActive?.map((teacher, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexInActive + index + 1}</th>
                                                                                            <td>{teacher.teacherName}</td>
                                                                                            <td>{teacher.email}</td>
                                                                                            <td>{dateFormate(teacher.joiningDate)}</td>
                                                                                            <td>{dateFormate(teacher.dob)}</td>
                                                                                            <td>{teacher.contactNumber}</td>
                                                                                            <td>{teacher.gender}</td>
                                                                                            <td>{teacher.qualification}</td>
                                                                                            <td>{teacher.address}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Inactive Teachers Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageInActive} setCurrPage={setCurrPageInActive} totalPages={totalPagesInActive} itemsPerPage={itemsPerPageInActive} setItemsPerPage={setItemsPerPageInActive} totalItem={inActiveList.length} />
                                                            </div>}

                                                        {isActive &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueActive}
                                                                        onChange={handleEmptySearchActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Teacher Name
                                                                                <SortIcon sortState={teacherNameActiveSort} setSortState={setTeacherNameActiveSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"teacherName"} />
                                                                            </th>
                                                                            <th scope="col">Email Id</th>
                                                                            <th scope="col">
                                                                                Joining Date
                                                                                <SortIcon sortState={joiningDateActiveSort} setSortState={setJoiningDateActiveSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"joiningDate"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Date Of Birth
                                                                                <SortIcon sortState={dobActiveSort} setSortState={setDobActiveSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"dob"} />
                                                                            </th>
                                                                            <th scope='col'>Mobile No</th>
                                                                            <th scope='col'>
                                                                                Gender
                                                                                <SortIcon sortState={genderActiveSort} setSortState={setGenderActiveSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"gender"} />
                                                                            </th>
                                                                            <th scope='col'>Qualification</th>
                                                                            <th scope='col'>Address</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataActive?.length > 0 ?
                                                                                displayedDataActive?.map((teacher, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexActive + index + 1}</th>
                                                                                            <td>{teacher.teacherName}</td>
                                                                                            <td>{teacher.email}</td>
                                                                                            <td>{dateFormate(teacher.joiningDate)}</td>
                                                                                            <td>{dateFormate(teacher.dob)}</td>
                                                                                            <td>{teacher.contactNumber}</td>
                                                                                            <td>{teacher.gender}</td>
                                                                                            <td>{teacher.qualification}</td>
                                                                                            <td>{teacher.address}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Active Teachers Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageActive} setCurrPage={setCurrPageActive} totalPages={totalPagesActive} itemsPerPage={itemsPerPageActive} setItemsPerPage={setItemsPerPageActive} totalItem={activeList.length} />
                                                            </div>}

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
};

export default InstituteDashboardTeacherList;